import * as React from 'react';
import { styled } from '@glitz/react';
import { loadScript } from '@avensia/excite';

type Props = {
  widgetHtml: string;
  scriptUrl: string;
  placeholder?: boolean;
};

export default function TrustpilotWidget({ widgetHtml, scriptUrl, placeholder = true }: Props) {
  const ref = React.useRef<HTMLDivElement>(null);
  const [shouldRenderWidget, setShouldRenderWidget] = React.useState(false);
  React.useEffect(() => {
    if (
      (__BROWSER__ && !window.CookieInformation) ||
      window.CookieInformation.getConsentGivenFor('cookie_cat_functional')
    ) {
      setShouldRenderWidget(true);
    }
  }, []);

  React.useEffect(() => {
    const renderWidget = () => {
      setShouldRenderWidget(true);
    };

    window.addEventListener('CookieInformationConsentGiven', renderWidget);

    return () => {
      window.removeEventListener('CookieInformationConsentGiven', renderWidget);
    };
  }, []);

  React.useEffect(() => {
    if (shouldRenderWidget) {
      loadScript(scriptUrl);
    }
  }, [shouldRenderWidget, scriptUrl]);

  return placeholder ? (
    <TrustpilotWidgetPlaceholder>
      {shouldRenderWidget ? <styled.Div ref={ref} dangerouslySetInnerHTML={{ __html: widgetHtml }} /> : <styled.Div />}
    </TrustpilotWidgetPlaceholder>
  ) : (
    <>
      {shouldRenderWidget ? <styled.Div ref={ref} dangerouslySetInnerHTML={{ __html: widgetHtml }} /> : <styled.Div />}
    </>
  );
}

const TrustpilotWidgetPlaceholder = styled.div({
  minHeight: 240,
});
